import { FacetTypes } from "../../constants/facet-types-enum";
import { FacetStateValues } from "../../models/state/facet-state-values";

import { RangeValues } from "../../models/types/type-range-values";

export const isFacetSelected = (
	selectedFacets: FacetStateValues,
	facet: any,
	selectedFacetValue: string[] | number | RangeValues,
): boolean => {
	var facetFound = false;

	if (Object.keys(selectedFacets).length === 0) {
		return false;
	}

	switch (facet.type) {
		case FacetTypes.Number:
			var numberFacet = selectedFacets[facet.fieldName] as number;

			if (numberFacet === undefined) {
				return false;
			}

			var selectedNumberValue = selectedFacetValue as number;
			facetFound = numberFacet === selectedNumberValue;
			break;
		case FacetTypes.Range:
			var rangeFacet = selectedFacets[facet.fieldName];
			var selectedRangeValue = selectedFacetValue as RangeValues;

			if (selectedRangeValue[0] === 0) {
				facetFound = false;
			} else {
				facetFound = rangeFacet[0] === selectedRangeValue[0];
			}
			break;
		case FacetTypes.Text:
			var textFacet = selectedFacets[facet.fieldName] as string[];

			if (textFacet === undefined) {
				return false;
			}

			var selectedTextValue = selectedFacetValue[0] as string;

			//Loop through selected values
			textFacet?.forEach((value) => {
				if (value === selectedTextValue) {
					facetFound = true;
				}
			});
			break;
	}
	return facetFound;
};
